import { ReactNode } from 'react';
import { Button } from '../../ui/Button/Button';
import S from './InfoModalStyles';

type Props = {
  /** Plain text for a one-line notice, or a node when the message needs structure. */
  title: ReactNode;
  btnConfirmText?: string;
  onClose: () => void;
};

function InfoModal({
  title, btnConfirmText = 'Accept', onClose,
} : Props): JSX.Element {
  return (
    <S.Wrapper>
      <div className="title">
        {title}
      </div>
      <div className="actions">
        <Button
          className="button"
          padding="7px 40px"
          onClick={onClose}
        >{btnConfirmText}
        </Button>
      </div>
    </S.Wrapper>
  );
}

export default InfoModal;
